import { useContext } from 'react';
import { MdArrowRightAlt } from 'react-icons/md';
import { Button } from '@ds';

import { AuthContext } from '@lp/core/auth';

import logoFullImg from '@lp/assets/images/transmedicsLogoFull.svg?url';

import { IS_PROD, SSO_IDENTITY_PROVIDER_SIGMA, SSO_IDENTITY_PROVIDER_TMDX } from '@/constants/env.constants';

import styles from './SignIn.module.scss';

const SignIn = () => {
  const { signIn } = useContext(AuthContext);

  const signInSigma = () => {
    signIn(SSO_IDENTITY_PROVIDER_SIGMA);
  };

  const signInTmdx = () => {
    signIn(SSO_IDENTITY_PROVIDER_TMDX);
  };

  return (
    <div className={styles.page}>
      <div className={styles.splash}>
        <img src={logoFullImg} alt="Transmedics Logo" className={styles.splashLogo} />
        <h1 className={styles.heading}>NOP Connect</h1>
      </div>
      <div className={styles.bottom}>
        <div className="flex flex-col gap-3">
          {!IS_PROD && (
            <Button variant="solid" size="lg" onClick={signInSigma} endContent={<MdArrowRightAlt size={35} />}>
              Sign In With SSO (SIGMA)
            </Button>
          )}
          <Button variant="solid" size="lg" onClick={signInTmdx} endContent={<MdArrowRightAlt size={35} />}>
            Sign In With SSO (TMDX)
          </Button>
        </div>
        <div className={styles.termsText}>
          <span>By signing in to use NOP Connect you are acknowledging your acceptance of</span>{' '}
          <div className={styles.links}>
            <a
              href="https://www.transmedics.com/terms-of-use/"
              className={styles.termsLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms & Conditions,
            </a>{' '}
            <a
              href="https://www.transmedics.com/nop-connect-privacy-policy/"
              className={styles.termsLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy.
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
